<script>
import { mapGetters } from 'vuex'

import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [
    Translatable
  ],
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('eShop', [
      'selectedType'
    ]),
    isActive() {
      return this.card.value === this.selectedType
    }
  },
  methods: {
    selectType(type) {
      this.$store.commit('eShop/changePassType', type)
    }
  },
}
</script>

<template>
  <div class="card-container">
    <div class="card-wrapper" @click="selectType(card.value)">
      <div :class="isActive ? 'circle-btn-selected' : 'circle-btn-empty'"></div>
      <div class="icon-container">
        <div class="icon" :class="isActive && 'selected'" :style="{ maskImage: `url(${card.icon})` }">
        </div>
      </div>
    </div>
    <div class="text">
      <p v-html="getTranslatedContent(card.text)"></p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-wrapper {
  cursor: pointer;
}

.card-container {
  width: 366px;
}

.icon-container {
  width: 100%;
  height: 258px;
  background: $light-gray;
  box-shadow: -2px 4px 4px rgba(57, 63, 117, 0.07);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.icon {
  width: 126px;
  height: 130px;
  mask-repeat: no-repeat;
  padding: auto;
  background-color: $dark-blue;

  &.selected {
    background-color: $orange;
  }
}

.text {
  margin-top: 20px;

  & p {
    font-family: Open Sans Semibold;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: $dark-blue;
  }
}

.circle-btn-mixin {
  cursor: pointer;
  min-width: 24px;
  width: 24px;
  height: 24px;
  position: relative;
  top: 34px;
  left: 12px;
  margin-top: -24px;
}

.circle-btn-empty {
  @extend .circle-btn-mixin;
  background: url("../../assets/icons/e-empty-circle.svg") center no-repeat;
}

.circle-btn-selected {
  @extend .circle-btn-mixin;
  background: url("../../assets/icons/e-selected-circle.svg") center no-repeat;
}

@media only screen and (max-width: $screen-width-xs) {
  .card-container {
    min-width: 146px;
    width: auto;
  }

  .icon-container {
    height: 123px;
  }

  .icon {
    transform: scale(0.65);
  }

  .text {
    & p {
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>
